import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { PostAnnouncementPayload } from '@sdk/announcements/types/apiTypes';

import { getAnnouncementsQueryKey } from '@web/announcements/utils/getQueryKey';

export const usePostAnnouncement = () => {
  const queryKey = getAnnouncementsQueryKey();
  const client = useQueryClient();
  const { announcements } = useSlingApi();

  const mutation = useMutation({
    mutationFn: (payload: PostAnnouncementPayload) => announcements.post(payload),
    onSuccess: () => {
      void client.cancelQueries(queryKey, { exact: true });
      void client.invalidateQueries(queryKey, { exact: true });
    },
  });

  return mutation;
};
